import { render, staticRenderFns } from "./SvgArrowLeft.vue?vue&type=template&id=31ab5f0b&"
import script from "./SvgArrowLeft.vue?vue&type=script&lang=js&"
export * from "./SvgArrowLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports